module.exports = __webpack_public_path__ + "media/src/images/balloons/womans_day_bg-5116305b0396b2635d0fa103ab4599f7.jpg";